export default "__VITE_ASSET__vl0dOU$J__"